import { CustomerQuote } from '@/@types/responses/customer_quote/CustomerQuote'
import { CustomerQuoteDetails } from '@/@types/responses/customer_quote/CustomerQuoteDetails'
import { PagingResponse } from '@/@types/responses/common/PagingResponse'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class CustomerQuoteService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public getCustomerQuote(id: number): Promise<CustomerQuoteDetails> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/customer-quotes/${id}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return new CustomerQuoteDetails(json.id, json.approvedDate, json.buildTypeName, json.cartridgeName, json.customer, json.customerSuppliedParts, json.expirationDate, json.parts, json.partsDiscountPercentage, json.services, json.servicesDiscountPercentage, json.total)
    })
  }

  public searchCustomerQuotes(pageNumber: number, pageSize: number, sortField: string, buildTypeId: number|undefined, cartridgeId: number|undefined, ascending: boolean): Promise<PagingResponse<CustomerQuote>> {
    let queryString = `?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&ascending=${ascending}`

    if (buildTypeId)
      queryString += `&buildTypeId=${buildTypeId}`

    if (cartridgeId)
      queryString += `&cartridgeId=${cartridgeId}`

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/customer-quotes${queryString}`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as PagingResponse<CustomerQuote>
    })
  }

  public updateCustomerQuote(quoteId: number): Promise<void> {
    const requestOptions = {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/customer-quotes/${quoteId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
